import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3149, { U3149ROLES } from './U3149';
import U3149WorkNatureList from './components/U3149WorkNatureList';
import U3149WorkNatureForm from './components/U3149WorkNatureForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3149Routes: RouteObject[] = [
  {
    path: 'U3149',
    element: <U2000RequireRole allowedRoles={[U3149ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3149 />,
        children: [
          { index: true, element: <U3149WorkNatureList /> },
          { path: ':id', element: <U3149WorkNatureForm /> },
        ],
      },
    ],
  },
];

export default U3149Routes;
